import { withTranslation } from 'react-i18next';
import React from 'react';

class GroupStatisticsComponent extends React.Component {

    renderCategoriesDetails(categories) {
        return categories.map(cat => {
            return (
                <li key={cat.name}>
                    {cat.name}
                    <span>{cat.amount}</span>
                </li>
            );
        })
    }

    renderSingleGroup(group) {
        return (
            <div className="col-12 col-md-6 col-lg-3" key={group.group}>
                <div className="group-box">
                    <h3>{group.group_name}</h3>
                    <ul className="group-list">
                        <li>
                            {this.props.t('statistics.tasksCompleted')}
                            <span>{group.total}</span>
                        </li>
                        {this.renderCategoriesDetails(group.categories)}
                    </ul>
                </div>
            </div>
        )
    }

    renderGroupStatistics() {
        return this.props.groups.map((group) => {
            return this.renderSingleGroup(group)
        })
    }

    render() {
        return (
            <div className="row statistics-group-row">
                <div className="col-12 statistics-head">
                    <h2>{this.props.t('statistics.perGroup')}</h2>
                </div>
                {this.renderGroupStatistics()}
            </div>
        )
    }
}

export const GroupStatistics = withTranslation()(GroupStatisticsComponent);
